
// import React, { useState } from 'react';
// import {
//   Box,
//   Typography,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Button,
//   Grid,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Card,
//   CardContent,
//   Divider,
//   Stack,
//   Container
// } from '@mui/material';
// import SaveIcon from '@mui/icons-material/Save';
// import CloseIcon from '@mui/icons-material/Close';
// import DownloadIcon from '@mui/icons-material/Download';
// import NoteAddIcon from '@mui/icons-material/NoteAdd';

// // Initial states
// const initialPureTone = {
//   mode: '', // New mode selection field
//   equipmentUsed: '',
//   results: {
//     rightAC: Array(10).fill(''),
//     rightBC: Array(10).fill(''),
//     leftAC: Array(10).fill(''),
//     leftBC: Array(10).fill('')
//   },
//   weber: ['', '', '', '']
// };

// const initialBoa = {
//   stimuli: Array(7).fill(''),
//   intensity: Array(7).fill(''),
//   response: Array(7).fill('')
// };

// const initialSpeech = {
//   equipmentUsed: '',
//   rightEar: { srt: '', sis: '', sdt: '', ucl: '' },
//   leftEar: { srt: '', sis: '', sdt: '', ucl: '' }
// };

// const initialOtoscopy = {
//   equipmentUsed: '',
//   rightEar: '',
//   leftEar: ''
// };

// const initialTympanometry = {
//   equipmentUsed: '',
//   rightEar: { type: '', pp: '', sa: '', width: '', ecv: '' },
//   leftEar: { type: '', pp: '', sa: '', width: '', ecv: '' },
//   interpretation: ''
// };

// const initialReflexometry = {
//   equipmentUsed: '',
//   rightEar: { ipsi: ['', '', '', ''], contra: ['', '', '', ''] },
//   leftEar: { ipsi: ['', '', '', ''], contra: ['', '', '', ''] },
//   interpretation: ''
// };

// const initialReflexDecay = {
//   equipmentUsed: '',
//   rightEar: ['', ''],
//   leftEar: ['', ''],
//   interpretation: ''
// };

// const initialOae = {
//   equipmentUsed: '',
//   teoae: {
//     rightEar: Array(5).fill({ freq: '', snr: '', amplitude: '' }),
//     leftEar: Array(5).fill({ freq: '', snr: '', amplitude: '' })
//   },
//   dpoae: {
//     rightEar: Array(5).fill({ freq: '', snr: '', amplitude: '' }),
//     leftEar: Array(5).fill({ freq: '', snr: '', amplitude: '' }),
//     parameters: { f2f1: '', l1: '', l2: '' }
//   },
//   interpretation: ''
// };

// const initialAbr = {
//   equipmentUsed: '',
//   transducers: '',
//   stimulusRate: '',
//   stimulusType: '',
//   ear: '',
//   response: '',
//   results: Array(8).fill('').map(() => Array(8).fill(''))
// };

// const initialLlr = {
//   equipmentUsed: '',
//   transducers: '',
//   stimulusRate: '',
//   stimulusType: '',
//   ear: '',
//   results: Array(8).fill('').map(() => Array(4).fill(''))
// };

// const HearingEvaluationChild = () => {
//   // Main states
//   const [date, setDate] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [saveStatus, setSaveStatus] = useState({ message: '', severity: '' });
//   const [openPasswordModal, setOpenPasswordModal] = useState(false);
//   const [password, setPassword] = useState('');
//   const [downloadFormat, setDownloadFormat] = useState('excel');
  
//   // Form states
//   const [pureTone, setPureTone] = useState(initialPureTone);
//   const [boa, setBoa] = useState(initialBoa);
//   const [speech, setSpeech] = useState(initialSpeech);
//   const [otoscopy, setOtoscopy] = useState(initialOtoscopy);
//   const [tympanometry, setTympanometry] = useState(initialTympanometry);
//   const [reflexometry, setReflexometry] = useState(initialReflexometry);
//   const [reflexDecay, setReflexDecay] = useState(initialReflexDecay);
//   const [oae, setOae] = useState(initialOae);
//   const [abr, setAbr] = useState(initialAbr);
//   const [llr, setLlr] = useState(initialLlr);

//   // Frequencies for pure tone audiometry
//   const frequencies = [250, 500, 750, 1000, 1500, 2000, 3000, 4000, 6000, 8000];

//   // BOA frequencies
//   const boaFrequencies = [250, 500, 1000, 2000, 4000, 'WBN', 'Speech'];

//   // Reset form function
//   const resetForm = () => {
//     setDate('');
//     setPureTone(initialPureTone);
//     setBoa(initialBoa);
//     setSpeech(initialSpeech);
//     setOtoscopy(initialOtoscopy);
//     setTympanometry(initialTympanometry);
//     setReflexometry(initialReflexometry);
//     setReflexDecay(initialReflexDecay);
//     setOae(initialOae);
//     setAbr(initialAbr);
//     setLlr(initialLlr);
//   };

//   // Handler functions
//   const handlePureToneChange = (e) => {
//     const { name, value } = e.target;
//     setPureTone(prev => ({ ...prev, [name]: value }));
//   };

//   const handlePureToneResultChange = (ear, mode, index, value) => {
//     setPureTone(prev => {
//       const newResults = { ...prev.results };
//       newResults[`${ear}${mode}`][index] = value;
//       return { ...prev, results: newResults };
//     });
//   };

//   const handleWeberChange = (index, value) => {
//     setPureTone(prev => {
//       const newWeber = [...prev.weber];
//       newWeber[index] = value;
//       return { ...prev, weber: newWeber };
//     });
//   };

//   // BOA handlers
//   const handleBoaChange = (field, index, value) => {
//     setBoa(prev => ({
//       ...prev,
//       [field]: prev[field].map((item, i) => i === index ? value : item)
//     }));
//   };

//   // OAE handlers
//   const handleOaeTeoaeChange = (ear, index, field, value) => {
//     setOae(prev => {
//       const newTeoae = { ...prev.teoae };
//       const newEarData = [...newTeoae[`${ear}Ear`]];
//       newEarData[index] = { ...newEarData[index], [field]: value };
//       newTeoae[`${ear}Ear`] = newEarData;
//       return { ...prev, teoae: newTeoae };
//     });
//   };

//   const handleOaeDpoaeChange = (ear, index, field, value) => {
//     setOae(prev => {
//       const newDpoae = { ...prev.dpoae };
//       const newEarData = [...newDpoae[`${ear}Ear`]];
//       newEarData[index] = { ...newEarData[index], [field]: value };
//       newDpoae[`${ear}Ear`] = newEarData;
//       return { ...prev, dpoae: newDpoae };
//     });
//   };

//   const handleOaeParamChange = (field, value) => {
//     setOae(prev => ({
//       ...prev,
//       dpoae: {
//         ...prev.dpoae,
//         parameters: {
//           ...prev.dpoae.parameters,
//           [field]: value
//         }
//       }
//     }));
//   };

//   // ABR handlers
//   const handleAbrChange = (field, value) => {
//     setAbr(prev => ({ ...prev, [field]: value }));
//   };

//   const handleAbrResultChange = (rowIndex, colIndex, value) => {
//     setAbr(prev => {
//       const newResults = prev.results.map((row, rIndex) => {
//         if (rIndex === rowIndex) {
//           return row.map((cell, cIndex) => (cIndex === colIndex ? value : cell));
//         }
//         return row;
//       });
//       return { ...prev, results: newResults };
//     });
//   };

//   // LLR handlers
//   const handleLlrChange = (field, value) => {
//     setLlr(prev => ({ ...prev, [field]: value }));
//   };

//   const handleLlrResultChange = (rowIndex, colIndex, value) => {
//     setLlr(prev => {
//       const newResults = prev.results.map((row, rIndex) => {
//         if (rIndex === rowIndex) {
//           return row.map((cell, cIndex) => (cIndex === colIndex ? value : cell));
//         }
//         return row;
//       });
//       return { ...prev, results: newResults };
//     });
//   };

//   // Save handlers for each section
//   const savePureTone = () => {
//     console.log('Pure Tone saved:', pureTone);
//     alert('Pure Tone Audiometry data saved!');
//   };

//   const saveBoa = () => {
//     console.log('BOA saved:', boa);
//     alert('Behavioral Observation Audiometry data saved!');
//   };

//   const saveSpeech = () => {
//     console.log('Speech saved:', speech);
//     alert('Speech Audiometry data saved!');
//   };

//   const saveOtoscopy = () => {
//     console.log('Otoscopy saved:', otoscopy);
//     alert('Otoscopy data saved!');
//   };

//   const saveTympanometry = () => {
//     console.log('Tympanometry saved:', tympanometry);
//     alert('Tympanometry data saved!');
//   };

//   const saveReflexometry = () => {
//     console.log('Reflexometry saved:', reflexometry);
//     alert('Reflexometry data saved!');
//   };

//   const saveReflexDecay = () => {
//     console.log('Reflex Decay saved:', reflexDecay);
//     alert('Reflex Decay data saved!');
//   };

//   const saveOae = () => {
//     console.log('OAE saved:', oae);
//     alert('OAE data saved!');
//   };

//   const saveAbr = () => {
//     console.log('ABR saved:', abr);
//     alert('ABR data saved!');
//   };

//   const saveLlr = () => {
//     console.log('LLR saved:', llr);
//     alert('LLR data saved!');
//   };

//   // Submit entire form
//   const handleSubmit = () => {
//     const allData = {
//       date,
//       pureTone,
//       boa,
//       speech,
//       otoscopy,
//       tympanometry,
//       reflexometry,
//       reflexDecay,
//       oae,
//       abr,
//       llr
//     };
//     console.log('All evaluation data:', allData);
//     alert('✅ Child Hearing Evaluation submitted successfully!');
//     resetForm();
//   };

//   const handleDownloadClick = () => {
//     setOpenPasswordModal(true);
//   };

//   const handleDownloadConfirm = async () => {
//     const correctKey = "Varun@6361";

//     if (password !== correctKey) {
//       alert("Incorrect key! Download canceled.");
//       setPassword('');
//       setOpenPasswordModal(false);
//       return;
//     }

//     setOpenPasswordModal(false);
//     setLoading(true);
//     setSaveStatus({
//       message: `Requesting Hearing Evaluation Data ${downloadFormat}...`,
//       severity: "info",
//     });

//     try {
//       const resp = await fetch(
//         "http://localhost:5000/api/reports/download-form",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             table: "hearing_evaluation_data",
//             formName: "Hearing_Evaluation_Data",
//             format: downloadFormat,
//             key: password
//           }),
//         }
//       );

//       if (!resp.ok) {
//         const body = await resp.json().catch(() => ({}));
//         setSaveStatus({
//           message: `Failed: ${body.message || resp.statusText}`,
//           severity: "error",
//         });
//         return;
//       }

//       const blob = await resp.blob();
//       const disposition = resp.headers.get("content-disposition") || "";

//       let filename = `Hearing_Evaluation_Data_${Date.now()}.${
//         downloadFormat === "excel" ? "xlsx" : "pdf"
//       }`;

//       const match = /filename="?([^"]+)"?/.exec(disposition);
//       if (match && match[1]) filename = match[1];

//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = filename;
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//       window.URL.revokeObjectURL(url);

//       setSaveStatus({
//         message: `Download started: ${filename}`,
//         severity: "success",
//       });

//     } catch (err) {
//       console.error("Download error:", err);
//       setSaveStatus({
//         message: `Error downloading file: ${err.message}`,
//         severity: "error",
//       });
//     } finally {
//       setLoading(false);
//       setPassword('');
//     }
//   };

//   const handlePasswordModalClose = () => {
//     setOpenPasswordModal(false);
//     setPassword('');
//   };

//   return (
//     <Container maxWidth="xl">
//       <Box sx={{ py: 4 }}>
//         {/* Header Section */}
//         <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0' }}>
//           <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
//             <Stack direction="row" alignItems="center" spacing={2}>
//               <NoteAddIcon sx={{ fontSize: 40, color: 'primary.main' }} />
//               <Box>
//                 <Typography variant="h4" fontWeight={600} color="text.primary">
//                   Child Hearing Evaluation
//                 </Typography>
//                 <Typography variant="subtitle1" color="text.secondary">
//                   Complete pediatric audiological assessment form
//                 </Typography>
//               </Box>
//             </Stack>
            
//             <Button
//               variant="outlined"
//               color="primary"
//               startIcon={<DownloadIcon />}
//               onClick={handleDownloadClick}
//               disabled={loading}
//               sx={{ 
//                 borderRadius: 2,
//                 px: 3,
//                 textTransform: 'none'
//               }}
//             >
//               Download Data
//             </Button>
//           </Stack>

//           {/* Date of Assessment */}
//           <Card variant="outlined">
//             <CardContent>
//               <Typography variant="h6" fontWeight={600} gutterBottom>
//                 Assessment Details
//               </Typography>
//               <Grid container spacing={3}>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     label="Date of Assessment"
//                     type="date"
//                     value={date}
//                     onChange={(e) => setDate(e.target.value)}
//                     InputLabelProps={{ shrink: true }}
//                   />
//                 </Grid>
//               </Grid>
//             </CardContent>
//           </Card>
//         </Paper>

//         {/* Main Form */}
//         <Paper elevation={0} sx={{ p: 4, border: '1px solid #e0e0e0' }}>
//           {/* Pure Tone Audiometry Section */}
//           <Box sx={{ mb: 5 }}>
//             <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
//               1. Pure Tone Audiometry
//             </Typography>
            
//             <Card variant="outlined">
//               <CardContent>
//                 <Grid container spacing={2} sx={{ mb: 3 }}>
//                   <Grid item xs={12} md={6}>
//                     <FormControl fullWidth>
//                       <InputLabel shrink={true}>Mode</InputLabel>
//                       <Select
//                         name="mode"
//                         value={pureTone.mode}
//                         onChange={handlePureToneChange}
//                         label="Mode"
//                         displayEmpty
//                       >
//                         <MenuItem value=""><em>Select Mode</em></MenuItem>
//                         <MenuItem value="VRA">VRA</MenuItem>
//                         <MenuItem value="CPA">CPA</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Equipment Used"
//                       name="equipmentUsed"
//                       value={pureTone.equipmentUsed}
//                       onChange={handlePureToneChange}
//                       variant="outlined"
//                     />
//                   </Grid>
//                 </Grid>

//                 <TableContainer component={Paper} sx={{ mb: 3 }}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 600 }}>Mode/Ear</TableCell>
//                         {frequencies.map(freq => (
//                           <TableCell key={freq} align="center" sx={{ fontWeight: 600 }}>{freq} Hz</TableCell>
//                         ))}
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {[['AC', 'Right'], ['BC', 'Right'], ['AC', 'Left'], ['BC', 'Left']].map(([mode, ear]) => (
//                         <TableRow key={`${mode}-${ear}`}>
//                           <TableCell sx={{ fontWeight: 500 }}>{mode} - {ear}</TableCell>
//                           {frequencies.map((_, index) => (
//                             <TableCell key={index} align="center">
//                               <TextField
//                                 size="small"
//                                 type="number"
//                                 value={pureTone.results[`${ear.toLowerCase()}${mode}`][index]}
//                                 onChange={(e) => handlePureToneResultChange(
//                                   ear.toLowerCase(),
//                                   mode,
//                                   index,
//                                   e.target.value
//                                 )}
//                                 sx={{ width: 70 }}
//                               />
//                             </TableCell>
//                           ))}
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>

//                 {/* Weber Test */}
//                 <Typography variant="subtitle1" fontWeight={600} gutterBottom sx={{ mt: 3 }}>
//                   Weber Test
//                 </Typography>
//                 <Grid container spacing={2} sx={{ mb: 2 }}>
//                   {[250, 500, 1000, 2000].map((freq, index) => (
//                     <Grid item xs={6} sm={3} key={freq}>
//                       <FormControl fullWidth>
//                         <InputLabel shrink={true}>{freq} Hz</InputLabel>
//                         <Select
//                           value={pureTone.weber[index]}
//                           onChange={(e) => handleWeberChange(index, e.target.value)}
//                           label={`${freq} Hz`}
//                           displayEmpty
//                         >
//                           <MenuItem value=""><em>Select Weber</em></MenuItem>
//                           <MenuItem value="L">Left</MenuItem>
//                           <MenuItem value="R">Right</MenuItem>
//                           <MenuItem value="C">Center</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>
//                   ))}
//                 </Grid>

//                 <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
//                   <Button
//                     variant="contained"
//                     startIcon={<SaveIcon />}
//                     onClick={savePureTone}
//                     sx={{ textTransform: 'none' }}
//                   >
//                     Save Pure Tone
//                   </Button>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Box>

//           <Divider sx={{ my: 4 }} />

//           {/* Behavioral Observation Audiometry Section */}
//           <Box sx={{ mb: 5 }}>
//             <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
//               2. Behavioral Observation Audiometry
//             </Typography>
            
//             <Card variant="outlined">
//               <CardContent>
//                 <TableContainer component={Paper} sx={{ mb: 3 }}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 600 }}></TableCell>
//                         {boaFrequencies.map(freq => (
//                           <TableCell key={freq} align="center" sx={{ fontWeight: 600 }}>{freq}</TableCell>
//                         ))}
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 500 }}>Intensity</TableCell>
//                         {boaFrequencies.map((_, index) => (
//                           <TableCell key={`intensity-${index}`} align="center">
//                             <TextField
//                               size="small"
//                               type="number"
//                               value={boa.intensity[index]}
//                               onChange={(e) => handleBoaChange('intensity', index, e.target.value)}
//                               sx={{ width: 80 }}
//                             />
//                           </TableCell>
//                         ))}
//                       </TableRow>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 500 }}>Response</TableCell>
//                         {boaFrequencies.map((_, index) => (
//                           <TableCell key={`response-${index}`} align="center">
//                             <TextField
//                               size="small"
//                               value={boa.response[index]}
//                               onChange={(e) => handleBoaChange('response', index, e.target.value)}
//                               sx={{ width: 80 }}
//                             />
//                           </TableCell>
//                         ))}
//                       </TableRow>
//                     </TableBody>
//                   </Table>
//                 </TableContainer>

//                 <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//                   <Button
//                     variant="contained"
//                     startIcon={<SaveIcon />}
//                     onClick={saveBoa}
//                     sx={{ textTransform: 'none' }}
//                   >
//                     Save BOA
//                   </Button>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Box>

//           <Divider sx={{ my: 4 }} />

//           {/* Speech Audiometry Section */}
//           <Box sx={{ mb: 5 }}>
//             <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
//               3. Speech Audiometry
//             </Typography>
            
//             <Card variant="outlined">
//               <CardContent>
//                 <Grid container spacing={2} sx={{ mb: 3 }}>
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Equipment Used"
//                       name="equipmentUsed"
//                       value={speech.equipmentUsed}
//                       onChange={(e) => setSpeech(prev => ({ ...prev, equipmentUsed: e.target.value }))}
//                       variant="outlined"
//                     />
//                   </Grid>
//                 </Grid>

//                 <TableContainer component={Paper} sx={{ mb: 3 }}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 600 }}>Ear</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>SRT (dB HL)</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>SIS (%)</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>SDT (dB HL)</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>UCL (dB HL)</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 500 }}>Right</TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             type="number"
//                             fullWidth
//                             value={speech.rightEar.srt}
//                             onChange={(e) => setSpeech(prev => ({
//                               ...prev,
//                               rightEar: { ...prev.rightEar, srt: e.target.value }
//                             }))}
//                           />
//                         </TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             type="number"
//                             fullWidth
//                             value={speech.rightEar.sis}
//                             onChange={(e) => setSpeech(prev => ({
//                               ...prev,
//                               rightEar: { ...prev.rightEar, sis: e.target.value }
//                             }))}
//                           />
//                         </TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             type="number"
//                             fullWidth
//                             value={speech.rightEar.sdt}
//                             onChange={(e) => setSpeech(prev => ({
//                               ...prev,
//                               rightEar: { ...prev.rightEar, sdt: e.target.value }
//                             }))}
//                           />
//                         </TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             type="number"
//                             fullWidth
//                             value={speech.rightEar.ucl}
//                             onChange={(e) => setSpeech(prev => ({
//                               ...prev,
//                               rightEar: { ...prev.rightEar, ucl: e.target.value }
//                             }))}
//                           />
//                         </TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 500 }}>Left</TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             type="number"
//                             fullWidth
//                             value={speech.leftEar.srt}
//                             onChange={(e) => setSpeech(prev => ({
//                               ...prev,
//                               leftEar: { ...prev.leftEar, srt: e.target.value }
//                             }))}
//                           />
//                         </TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             type="number"
//                             fullWidth
//                             value={speech.leftEar.sis}
//                             onChange={(e) => setSpeech(prev => ({
//                               ...prev,
//                               leftEar: { ...prev.leftEar, sis: e.target.value }
//                             }))}
//                           />
//                         </TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             type="number"
//                             fullWidth
//                             value={speech.leftEar.sdt}
//                             onChange={(e) => setSpeech(prev => ({
//                               ...prev,
//                               leftEar: { ...prev.leftEar, sdt: e.target.value }
//                             }))}
//                           />
//                         </TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             type="number"
//                             fullWidth
//                             value={speech.leftEar.ucl}
//                             onChange={(e) => setSpeech(prev => ({
//                               ...prev,
//                               leftEar: { ...prev.leftEar, ucl: e.target.value }
//                             }))}
//                           />
//                         </TableCell>
//                       </TableRow>
//                     </TableBody>
//                   </Table>
//                 </TableContainer>

//                 <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//                   <Button
//                     variant="contained"
//                     startIcon={<SaveIcon />}
//                     onClick={saveSpeech}
//                     sx={{ textTransform: 'none' }}
//                   >
//                     Save Speech
//                   </Button>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Box>

//           <Divider sx={{ my: 4 }} />

//           {/* Otoscopy Section */}
//           <Box sx={{ mb: 5 }}>
//             <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
//               4. Otoscopy
//             </Typography>
            
//             <Card variant="outlined">
//               <CardContent>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Equipment Used"
//                       value={otoscopy.equipmentUsed}
//                       onChange={(e) => setOtoscopy(prev => ({ ...prev, equipmentUsed: e.target.value }))}
//                       variant="outlined"
//                     />
//                   </Grid>
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Right Ear Findings"
//                       value={otoscopy.rightEar}
//                       onChange={(e) => setOtoscopy(prev => ({ ...prev, rightEar: e.target.value }))}
//                       variant="outlined"
//                     />
//                   </Grid>
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Left Ear Findings"
//                       value={otoscopy.leftEar}
//                       onChange={(e) => setOtoscopy(prev => ({ ...prev, leftEar: e.target.value }))}
//                       variant="outlined"
//                     />
//                   </Grid>
//                 </Grid>

//                 <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
//                   <Button
//                     variant="contained"
//                     startIcon={<SaveIcon />}
//                     onClick={saveOtoscopy}
//                     sx={{ textTransform: 'none' }}
//                   >
//                     Save Otoscopy
//                   </Button>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Box>

//           <Divider sx={{ my: 4 }} />

//           {/* Tympanometry Section */}
//           <Box sx={{ mb: 5 }}>
//             <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
//               5. Tympanometry
//             </Typography>
            
//             <Card variant="outlined">
//               <CardContent>
//                 <Grid container spacing={2} sx={{ mb: 3 }}>
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Equipment Used"
//                       value={tympanometry.equipmentUsed}
//                       onChange={(e) => setTympanometry(prev => ({ ...prev, equipmentUsed: e.target.value }))}
//                       variant="outlined"
//                     />
//                   </Grid>
//                 </Grid>

//                 <TableContainer component={Paper} sx={{ mb: 3 }}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 600 }}>Ear</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>Type</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>PP (daPa)</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>SA (mmho)</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>Width (daPa)</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>ECV (cc)</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 500 }}>Right</TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             value={tympanometry.rightEar.type}
//                             onChange={(e) => setTympanometry(prev => ({
//                               ...prev,
//                               rightEar: { ...prev.rightEar, type: e.target.value }
//                             }))}
//                             fullWidth
//                           />
//                         </TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             type="number"
//                             value={tympanometry.rightEar.pp}
//                             onChange={(e) => setTympanometry(prev => ({
//                               ...prev,
//                               rightEar: { ...prev.rightEar, pp: e.target.value }
//                             }))}
//                             fullWidth
//                           />
//                         </TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             type="number"
//                             value={tympanometry.rightEar.sa}
//                             onChange={(e) => setTympanometry(prev => ({
//                               ...prev,
//                               rightEar: { ...prev.rightEar, sa: e.target.value }
//                             }))}
//                             fullWidth
//                           />
//                         </TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             type="number"
//                             value={tympanometry.rightEar.width}
//                             onChange={(e) => setTympanometry(prev => ({
//                               ...prev,
//                               rightEar: { ...prev.rightEar, width: e.target.value }
//                             }))}
//                             fullWidth
//                           />
//                         </TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             type="number"
//                             value={tympanometry.rightEar.ecv}
//                             onChange={(e) => setTympanometry(prev => ({
//                               ...prev,
//                               rightEar: { ...prev.rightEar, ecv: e.target.value }
//                             }))}
//                             fullWidth
//                           />
//                         </TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 500 }}>Left</TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             value={tympanometry.leftEar.type}
//                             onChange={(e) => setTympanometry(prev => ({
//                               ...prev,
//                               leftEar: { ...prev.leftEar, type: e.target.value }
//                             }))}
//                             fullWidth
//                           />
//                         </TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             type="number"
//                             value={tympanometry.leftEar.pp}
//                             onChange={(e) => setTympanometry(prev => ({
//                               ...prev,
//                               leftEar: { ...prev.leftEar, pp: e.target.value }
//                             }))}
//                             fullWidth
//                           />
//                         </TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             type="number"
//                             value={tympanometry.leftEar.sa}
//                             onChange={(e) => setTympanometry(prev => ({
//                               ...prev,
//                               leftEar: { ...prev.leftEar, sa: e.target.value }
//                             }))}
//                             fullWidth
//                           />
//                         </TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             type="number"
//                             value={tympanometry.leftEar.width}
//                             onChange={(e) => setTympanometry(prev => ({
//                               ...prev,
//                               leftEar: { ...prev.leftEar, width: e.target.value }
//                             }))}
//                             fullWidth
//                           />
//                         </TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             size="small"
//                             type="number"
//                             value={tympanometry.leftEar.ecv}
//                             onChange={(e) => setTympanometry(prev => ({
//                               ...prev,
//                               leftEar: { ...prev.leftEar, ecv: e.target.value }
//                             }))}
//                             fullWidth
//                           />
//                         </TableCell>
//                       </TableRow>
//                     </TableBody>
//                   </Table>
//                 </TableContainer>

//                 <TextField
//                   fullWidth
//                   multiline
//                   rows={3}
//                   label="Interpretation"
//                   value={tympanometry.interpretation}
//                   onChange={(e) => setTympanometry(prev => ({ ...prev, interpretation: e.target.value }))}
//                   variant="outlined"
//                   sx={{ mb: 2 }}
//                 />

//                 <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//                   <Button
//                     variant="contained"
//                     startIcon={<SaveIcon />}
//                     onClick={saveTympanometry}
//                     sx={{ textTransform: 'none' }}
//                   >
//                     Save Tympanometry
//                   </Button>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Box>

//           <Divider sx={{ my: 4 }} />

//           {/* Reflexometry Section */}
//           <Box sx={{ mb: 5 }}>
//             <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
//               6. Reflexometry
//             </Typography>
            
//             <Card variant="outlined">
//               <CardContent>
//                 <Grid container spacing={2} sx={{ mb: 3 }}>
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Equipment Used"
//                       value={reflexometry.equipmentUsed}
//                       onChange={(e) => setReflexometry(prev => ({ ...prev, equipmentUsed: e.target.value }))}
//                       variant="outlined"
//                     />
//                   </Grid>
//                 </Grid>

//                 <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//                   Right Ear
//                 </Typography>
//                 <TableContainer component={Paper} sx={{ mb: 3 }}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 600 }}>Type</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>500 Hz</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>1000 Hz</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>2000 Hz</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>4000 Hz</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 500 }}>IPSI</TableCell>
//                         {[0, 1, 2, 3].map((index) => (
//                           <TableCell key={`right-ipsi-${index}`} align="center">
//                             <TextField
//                               size="small"
//                               type="number"
//                               fullWidth
//                               value={reflexometry.rightEar.ipsi[index]}
//                               onChange={(e) => {
//                                 const newIpsi = [...reflexometry.rightEar.ipsi];
//                                 newIpsi[index] = e.target.value;
//                                 setReflexometry(prev => ({
//                                   ...prev,
//                                   rightEar: { ...prev.rightEar, ipsi: newIpsi }
//                                 }));
//                               }}
//                             />
//                           </TableCell>
//                         ))}
//                       </TableRow>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 500 }}>CONTRA</TableCell>
//                         {[0, 1, 2, 3].map((index) => (
//                           <TableCell key={`right-contra-${index}`} align="center">
//                             <TextField
//                               size="small"
//                               type="number"
//                               fullWidth
//                               value={reflexometry.rightEar.contra[index]}
//                               onChange={(e) => {
//                                 const newContra = [...reflexometry.rightEar.contra];
//                                 newContra[index] = e.target.value;
//                                 setReflexometry(prev => ({
//                                   ...prev,
//                                   rightEar: { ...prev.rightEar, contra: newContra }
//                                 }));
//                               }}
//                             />
//                           </TableCell>
//                         ))}
//                       </TableRow>
//                     </TableBody>
//                   </Table>
//                 </TableContainer>

//                 <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//                   Left Ear
//                 </Typography>
//                 <TableContainer component={Paper} sx={{ mb: 3 }}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 600 }}>Type</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>500 Hz</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>1000 Hz</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>2000 Hz</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>4000 Hz</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 500 }}>IPSI</TableCell>
//                         {[0, 1, 2, 3].map((index) => (
//                           <TableCell key={`left-ipsi-${index}`} align="center">
//                             <TextField
//                               size="small"
//                               type="number"
//                               fullWidth
//                               value={reflexometry.leftEar.ipsi[index]}
//                               onChange={(e) => {
//                                 const newIpsi = [...reflexometry.leftEar.ipsi];
//                                 newIpsi[index] = e.target.value;
//                                 setReflexometry(prev => ({
//                                   ...prev,
//                                   leftEar: { ...prev.leftEar, ipsi: newIpsi }
//                                 }));
//                               }}
//                             />
//                           </TableCell>
//                         ))}
//                       </TableRow>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 500 }}>CONTRA</TableCell>
//                         {[0, 1, 2, 3].map((index) => (
//                           <TableCell key={`left-contra-${index}`} align="center">
//                             <TextField
//                               size="small"
//                               type="number"
//                               fullWidth
//                               value={reflexometry.leftEar.contra[index]}
//                               onChange={(e) => {
//                                 const newContra = [...reflexometry.leftEar.contra];
//                                 newContra[index] = e.target.value;
//                                 setReflexometry(prev => ({
//                                   ...prev,
//                                   leftEar: { ...prev.leftEar, contra: newContra }
//                                 }));
//                               }}
//                             />
//                           </TableCell>
//                         ))}
//                       </TableRow>
//                     </TableBody>
//                   </Table>
//                 </TableContainer>

//                 <TextField
//                   fullWidth
//                   multiline
//                   rows={3}
//                   label="Interpretation"
//                   value={reflexometry.interpretation}
//                   onChange={(e) => setReflexometry(prev => ({ ...prev, interpretation: e.target.value }))}
//                   variant="outlined"
//                   sx={{ mb: 2 }}
//                 />

//                 <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//                   <Button
//                     variant="contained"
//                     startIcon={<SaveIcon />}
//                     onClick={saveReflexometry}
//                     sx={{ textTransform: 'none' }}
//                   >
//                     Save Reflexometry
//                   </Button>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Box>

//           <Divider sx={{ my: 4 }} />

//           {/* Reflex Decay Section */}
//           <Box sx={{ mb: 5 }}>
//             <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
//               7. Reflex Decay
//             </Typography>
            
//             <Card variant="outlined">
//               <CardContent>
//                 <Grid container spacing={2} sx={{ mb: 3 }}>
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Equipment Used"
//                       value={reflexDecay.equipmentUsed}
//                       onChange={(e) => setReflexDecay(prev => ({ ...prev, equipmentUsed: e.target.value }))}
//                       variant="outlined"
//                     />
//                   </Grid>
//                 </Grid>

//                 <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//                   Right Ear
//                 </Typography>
//                 <Grid container spacing={2} sx={{ mb: 3 }}>
//                   <Grid item xs={6}>
//                     <FormControl fullWidth>
//                       <InputLabel shrink={true}>500 Hz</InputLabel>
//                       <Select
//                         value={reflexDecay.rightEar[0]}
//                         onChange={(e) => {
//                           const newRightEar = [...reflexDecay.rightEar];
//                           newRightEar[0] = e.target.value;
//                           setReflexDecay(prev => ({ ...prev, rightEar: newRightEar }));
//                         }}
//                         label="500 Hz"
//                         displayEmpty
//                       >
//                         <MenuItem value=""><em>Select</em></MenuItem>
//                         <MenuItem value="Positive">Positive</MenuItem>
//                         <MenuItem value="Negative">Negative</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={6}>
//                     <FormControl fullWidth>
//                       <InputLabel shrink={true}>1000 Hz</InputLabel>
//                       <Select
//                         value={reflexDecay.rightEar[1]}
//                         onChange={(e) => {
//                           const newRightEar = [...reflexDecay.rightEar];
//                           newRightEar[1] = e.target.value;
//                           setReflexDecay(prev => ({ ...prev, rightEar: newRightEar }));
//                         }}
//                         label="1000 Hz"
//                         displayEmpty
//                       >
//                         <MenuItem value=""><em>Select</em></MenuItem>
//                         <MenuItem value="Positive">Positive</MenuItem>
//                         <MenuItem value="Negative">Negative</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>

//                 <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//                   Left Ear
//                 </Typography>
//                 <Grid container spacing={2} sx={{ mb: 3 }}>
//                   <Grid item xs={6}>
//                     <FormControl fullWidth>
//                       <InputLabel shrink={true}>500 Hz</InputLabel>
//                       <Select
//                         value={reflexDecay.leftEar[0]}
//                         onChange={(e) => {
//                           const newLeftEar = [...reflexDecay.leftEar];
//                           newLeftEar[0] = e.target.value;
//                           setReflexDecay(prev => ({ ...prev, leftEar: newLeftEar }));
//                         }}
//                         label="500 Hz"
//                         displayEmpty
//                       >
//                         <MenuItem value=""><em>Select</em></MenuItem>
//                         <MenuItem value="Positive">Positive</MenuItem>
//                         <MenuItem value="Negative">Negative</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={6}>
//                     <FormControl fullWidth>
//                       <InputLabel shrink={true}>1000 Hz</InputLabel>
//                       <Select
//                         value={reflexDecay.leftEar[1]}
//                         onChange={(e) => {
//                           const newLeftEar = [...reflexDecay.leftEar];
//                           newLeftEar[1] = e.target.value;
//                           setReflexDecay(prev => ({ ...prev, leftEar: newLeftEar }));
//                         }}
//                         label="1000 Hz"
//                         displayEmpty
//                       >
//                         <MenuItem value=""><em>Select</em></MenuItem>
//                         <MenuItem value="Positive">Positive</MenuItem>
//                         <MenuItem value="Negative">Negative</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>

//                 <TextField
//                   fullWidth
//                   multiline
//                   rows={3}
//                   label="Interpretation"
//                   value={reflexDecay.interpretation}
//                   onChange={(e) => setReflexDecay(prev => ({ ...prev, interpretation: e.target.value }))}
//                   variant="outlined"
//                   sx={{ mb: 2 }}
//                 />

//                 <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//                   <Button
//                     variant="contained"
//                     startIcon={<SaveIcon />}
//                     onClick={saveReflexDecay}
//                     sx={{ textTransform: 'none' }}
//                   >
//                     Save Reflex Decay
//                   </Button>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Box>

//           <Divider sx={{ my: 4 }} />

//           {/* OAE Section */}
//           <Box sx={{ mb: 5 }}>
//             <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
//               8. Oto-acoustic Emissions (OAE)
//             </Typography>
            
//             <Card variant="outlined">
//               <CardContent>
//                 <Grid container spacing={2} sx={{ mb: 3 }}>
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Equipment Used"
//                       value={oae.equipmentUsed}
//                       onChange={(e) => setOae(prev => ({ ...prev, equipmentUsed: e.target.value }))}
//                       variant="outlined"
//                     />
//                   </Grid>
//                 </Grid>

//                 {/* TEOAE Section */}
//                 <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//                   TEOAE
//                 </Typography>
//                 <Grid container spacing={3} sx={{ mb: 4 }}>
//                   <Grid item xs={12} md={6}>
//                     <Typography variant="subtitle2" fontWeight={600} gutterBottom>Right Ear</Typography>
//                     <TableContainer component={Paper} sx={{ mb: 2 }}>
//                       <Table size="small">
//                         <TableHead>
//                           <TableRow>
//                             <TableCell sx={{ fontWeight: 600 }}>Frequency (KHz)</TableCell>
//                             <TableCell align="center" sx={{ fontWeight: 600 }}>SNR (dB SPL)</TableCell>
//                             <TableCell align="center" sx={{ fontWeight: 600 }}>Amplitude (dB SPL)</TableCell>
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {oae.teoae.rightEar.map((result, index) => (
//                             <TableRow key={`teoae-right-${index}`}>
//                               <TableCell>
//                                 <TextField
//                                   size="small"
//                                   value={result.freq}
//                                   onChange={(e) => handleOaeTeoaeChange('right', index, 'freq', e.target.value)}
//                                   fullWidth
//                                 />
//                               </TableCell>
//                               <TableCell align="center">
//                                 <TextField
//                                   size="small"
//                                   type="number"
//                                   value={result.snr}
//                                   onChange={(e) => handleOaeTeoaeChange('right', index, 'snr', e.target.value)}
//                                   fullWidth
//                                 />
//                               </TableCell>
//                               <TableCell align="center">
//                                 <TextField
//                                   size="small"
//                                   type="number"
//                                   value={result.amplitude}
//                                   onChange={(e) => handleOaeTeoaeChange('right', index, 'amplitude', e.target.value)}
//                                   fullWidth
//                                 />
//                               </TableCell>
//                             </TableRow>
//                           ))}
//                         </TableBody>
//                       </Table>
//                     </TableContainer>
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <Typography variant="subtitle2" fontWeight={600} gutterBottom>Left Ear</Typography>
//                     <TableContainer component={Paper}>
//                       <Table size="small">
//                         <TableHead>
//                           <TableRow>
//                             <TableCell sx={{ fontWeight: 600 }}>Frequency (KHz)</TableCell>
//                             <TableCell align="center" sx={{ fontWeight: 600 }}>SNR (dB SPL)</TableCell>
//                             <TableCell align="center" sx={{ fontWeight: 600 }}>Amplitude (dB SPL)</TableCell>
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {oae.teoae.leftEar.map((result, index) => (
//                             <TableRow key={`teoae-left-${index}`}>
//                               <TableCell>
//                                 <TextField
//                                   size="small"
//                                   value={result.freq}
//                                   onChange={(e) => handleOaeTeoaeChange('left', index, 'freq', e.target.value)}
//                                   fullWidth
//                                 />
//                               </TableCell>
//                               <TableCell align="center">
//                                 <TextField
//                                   size="small"
//                                   type="number"
//                                   value={result.snr}
//                                   onChange={(e) => handleOaeTeoaeChange('left', index, 'snr', e.target.value)}
//                                   fullWidth
//                                 />
//                               </TableCell>
//                               <TableCell align="center">
//                                 <TextField
//                                   size="small"
//                                   type="number"
//                                   value={result.amplitude}
//                                   onChange={(e) => handleOaeTeoaeChange('left', index, 'amplitude', e.target.value)}
//                                   fullWidth
//                                 />
//                               </TableCell>
//                             </TableRow>
//                           ))}
//                         </TableBody>
//                       </Table>
//                     </TableContainer>
//                   </Grid>
//                 </Grid>

//                 {/* DPOAE Section */}
//                 <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//                   DPOAE
//                 </Typography>

//                 <Grid container spacing={2} sx={{ mb: 3 }}>
//                   <Grid item xs={4}>
//                     <TextField
//                       fullWidth
//                       label="f2/f1"
//                       variant="outlined"
//                       value={oae.dpoae.parameters.f2f1}
//                       onChange={(e) => handleOaeParamChange('f2f1', e.target.value)}
//                     />
//                   </Grid>
//                   <Grid item xs={4}>
//                     <TextField
//                       fullWidth
//                       label="L1"
//                       variant="outlined"
//                       value={oae.dpoae.parameters.l1}
//                       onChange={(e) => handleOaeParamChange('l1', e.target.value)}
//                     />
//                   </Grid>
//                   <Grid item xs={4}>
//                     <TextField
//                       fullWidth
//                       label="L2"
//                       variant="outlined"
//                       value={oae.dpoae.parameters.l2}
//                       onChange={(e) => handleOaeParamChange('l2', e.target.value)}
//                     />
//                   </Grid>
//                 </Grid>
//                 <Grid container spacing={3} sx={{ mb: 4 }}>
//                   <Grid item xs={12} md={6}>
//                     <Typography variant="subtitle2" fontWeight={600} gutterBottom>Right Ear</Typography>
//                     <TableContainer component={Paper} sx={{ mb: 2 }}>
//                       <Table size="small">
//                         <TableHead>
//                           <TableRow>
//                             <TableCell sx={{ fontWeight: 600 }}>Frequency (Hz)</TableCell>
//                             <TableCell align="center" sx={{ fontWeight: 600 }}>SNR (dB SPL)</TableCell>
//                             <TableCell align="center" sx={{ fontWeight: 600 }}>Amplitude (dB SPL)</TableCell>
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {oae.dpoae.rightEar.map((result, index) => (
//                             <TableRow key={`dpoae-right-${index}`}>
//                               <TableCell>
//                                 <TextField
//                                   size="small"
//                                   value={result.freq}
//                                   onChange={(e) => handleOaeDpoaeChange('right', index, 'freq', e.target.value)}
//                                   fullWidth
//                                 />
//                               </TableCell>
//                               <TableCell align="center">
//                                 <TextField
//                                   size="small"
//                                   type="number"
//                                   value={result.snr}
//                                   onChange={(e) => handleOaeDpoaeChange('right', index, 'snr', e.target.value)}
//                                   fullWidth
//                                 />
//                               </TableCell>
//                               <TableCell align="center">
//                                 <TextField
//                                   size="small"
//                                   type="number"
//                                   value={result.amplitude}
//                                   onChange={(e) => handleOaeDpoaeChange('right', index, 'amplitude', e.target.value)}
//                                   fullWidth
//                                 />
//                               </TableCell>
//                             </TableRow>
//                           ))}
//                         </TableBody>
//                       </Table>
//                     </TableContainer>
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <Typography variant="subtitle2" fontWeight={600} gutterBottom>Left Ear</Typography>
//                     <TableContainer component={Paper}>
//                       <Table size="small">
//                         <TableHead>
//                           <TableRow>
//                             <TableCell sx={{ fontWeight: 600 }}>Frequency (Hz)</TableCell>
//                             <TableCell align="center" sx={{ fontWeight: 600 }}>SNR (dB SPL)</TableCell>
//                             <TableCell align="center" sx={{ fontWeight: 600 }}>Amplitude (dB SPL)</TableCell>
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {oae.dpoae.leftEar.map((result, index) => (
//                             <TableRow key={`dpoae-left-${index}`}>
//                               <TableCell>
//                                 <TextField
//                                   size="small"
//                                   value={result.freq}
//                                   onChange={(e) => handleOaeDpoaeChange('left', index, 'freq', e.target.value)}
//                                   fullWidth
//                                 />
//                               </TableCell>
//                               <TableCell align="center">
//                                 <TextField
//                                   size="small"
//                                   type="number"
//                                   value={result.snr}
//                                   onChange={(e) => handleOaeDpoaeChange('left', index, 'snr', e.target.value)}
//                                   fullWidth
//                                 />
//                               </TableCell>
//                               <TableCell align="center">
//                                 <TextField
//                                   size="small"
//                                   type="number"
//                                   value={result.amplitude}
//                                   onChange={(e) => handleOaeDpoaeChange('left', index, 'amplitude', e.target.value)}
//                                   fullWidth
//                                 />
//                               </TableCell>
//                             </TableRow>
//                           ))}
//                         </TableBody>
//                       </Table>
//                     </TableContainer>
//                   </Grid>
//                 </Grid>

//                 <TextField
//                   fullWidth
//                   multiline
//                   rows={3}
//                   label="Interpretation"
//                   value={oae.interpretation}
//                   onChange={(e) => setOae(prev => ({ ...prev, interpretation: e.target.value }))}
//                   variant="outlined"
//                   sx={{ mb: 2 }}
//                 />

//                 <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//                   <Button
//                     variant="contained"
//                     startIcon={<SaveIcon />}
//                     onClick={saveOae}
//                     sx={{ textTransform: 'none' }}
//                   >
//                     Save OAE
//                   </Button>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Box>

//           <Divider sx={{ my: 4 }} />

//           {/* ABR Section */}
//           <Box sx={{ mb: 5 }}>
//             <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
//               9. Auditory Brainstem Response (ABR)
//             </Typography>
            
//             <Card variant="outlined">
//               <CardContent>
//                 <Grid container spacing={2} sx={{ mb: 3 }}>
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Equipment Used"
//                       value={abr.equipmentUsed}
//                       onChange={(e) => handleAbrChange('equipmentUsed', e.target.value)}
//                       variant="outlined"
//                     />
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <FormControl fullWidth>
//                       <InputLabel shrink={true}>Transducers</InputLabel>
//                       <Select
//                         value={abr.transducers}
//                         onChange={(e) => handleAbrChange('transducers', e.target.value)}
//                         label="Transducers"
//                         displayEmpty
//                       >
//                         <MenuItem value=""><em>Select Transducer</em></MenuItem>
//                         <MenuItem value="Insert receiver">Insert receiver</MenuItem>
//                         <MenuItem value="BC">BC</MenuItem>
//                         <MenuItem value="Headphones">Headphones</MenuItem>
//                         <MenuItem value="Loudspeaker">Loudspeaker</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <FormControl fullWidth>
//                       <InputLabel shrink={true}>Stimulus Rate</InputLabel>
//                       <Select
//                         value={abr.stimulusRate}
//                         onChange={(e) => handleAbrChange('stimulusRate', e.target.value)}
//                         label="Stimulus Rate"
//                         displayEmpty
//                       >
//                         <MenuItem value=""><em>Select Stimulus Rate</em></MenuItem>
//                         <MenuItem value="11.1">11.1</MenuItem>
//                         <MenuItem value="30.1">30.1</MenuItem>
//                         <MenuItem value="90.1">90.1</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <FormControl fullWidth>
//                       <InputLabel shrink={true}>Stimulus Type</InputLabel>
//                       <Select
//                         value={abr.stimulusType}
//                         onChange={(e) => handleAbrChange('stimulusType', e.target.value)}
//                         label="Stimulus Type"
//                         displayEmpty
//                       >
//                         <MenuItem value=""><em>Select Stimulus Type</em></MenuItem>
//                         <MenuItem value="Click">Click</MenuItem>
//                         <MenuItem value="TB500">TB500</MenuItem>
//                         <MenuItem value="TB1000">TB1000</MenuItem>
//                         <MenuItem value="TB2000">TB2000</MenuItem>
//                         <MenuItem value="TB4000">TB4000</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <FormControl fullWidth>
//                       <InputLabel shrink={true}>Ear</InputLabel>
//                       <Select
//                         value={abr.ear}
//                         onChange={(e) => handleAbrChange('ear', e.target.value)}
//                         label="Ear"
//                         displayEmpty
//                       >
//                         <MenuItem value=""><em>Select Ear</em></MenuItem>
//                         <MenuItem value="Right">Right</MenuItem>
//                         <MenuItem value="Left">Left</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <FormControl fullWidth>
//                       <InputLabel shrink={true}>Response</InputLabel>
//                       <Select
//                         value={abr.response}
//                         onChange={(e) => handleAbrChange('response', e.target.value)}
//                         label="Response"
//                         displayEmpty
//                       >
//                         <MenuItem value=""><em>Select Response</em></MenuItem>
//                         <MenuItem value="Latency">Latency</MenuItem>
//                         <MenuItem value="Amplitude">Amplitude</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>

//                 <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//                   Results
//                 </Typography>
//                 <TableContainer component={Paper} sx={{ mb: 3 }}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 600 }}>Intensity (dB)</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>I</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>II</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>III</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>IV</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>V</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>I-III</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>III-V</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>V/I</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>Interaural V</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {[90, 80, 70, 60, 50, 40, 30, 20].map((intensity, rowIndex) => (
//                         <TableRow key={intensity}>
//                           <TableCell sx={{ fontWeight: 500 }}>{intensity}</TableCell>
//                           {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((colIndex) => (
//                             <TableCell key={colIndex} align="center">
//                               <TextField
//                                 size="small"
//                                 fullWidth
//                                 value={abr.results[rowIndex][colIndex]}
//                                 onChange={(e) => handleAbrResultChange(rowIndex, colIndex, e.target.value)}
//                               />
//                             </TableCell>
//                           ))}
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>

//                 <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//                   <Button
//                     variant="contained"
//                     startIcon={<SaveIcon />}
//                     onClick={saveAbr}
//                     sx={{ textTransform: 'none' }}
//                   >
//                     Save ABR
//                   </Button>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Box>

//           <Divider sx={{ my: 4 }} />

//           {/* LLR Section */}
//           <Box sx={{ mb: 5 }}>
//             <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
//               10. Late Latency Response (LLR)
//             </Typography>
            
//             <Card variant="outlined">
//               <CardContent>
//                 <Grid container spacing={2} sx={{ mb: 3 }}>
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Equipment Used"
//                       value={llr.equipmentUsed}
//                       onChange={(e) => handleLlrChange('equipmentUsed', e.target.value)}
//                       variant="outlined"
//                     />
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <FormControl fullWidth>
//                       <InputLabel shrink={true}>Transducers</InputLabel>
//                       <Select
//                         value={llr.transducers}
//                         onChange={(e) => handleLlrChange('transducers', e.target.value)}
//                         label="Transducers"
//                         displayEmpty
//                       >
//                         <MenuItem value=""><em>Select Transducer</em></MenuItem>
//                         <MenuItem value="Insert receiver">Insert receiver</MenuItem>
//                         <MenuItem value="BC">BC</MenuItem>
//                         <MenuItem value="Headphones">Headphones</MenuItem>
//                         <MenuItem value="Loudspeaker">Loudspeaker</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <FormControl fullWidth>
//                       <InputLabel shrink={true}>Stimulus Rate</InputLabel>
//                       <Select
//                         value={llr.stimulusRate}
//                         onChange={(e) => handleLlrChange('stimulusRate', e.target.value)}
//                         label="Stimulus Rate"
//                         displayEmpty
//                       >
//                         <MenuItem value=""><em>Select Stimulus Rate</em></MenuItem>
//                         <MenuItem value="11.1">11.1</MenuItem>
//                         <MenuItem value="30.1">30.1</MenuItem>
//                         <MenuItem value="90.1">90.1</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <FormControl fullWidth>
//                       <InputLabel shrink={true}>Stimulus Type</InputLabel>
//                       <Select
//                         value={llr.stimulusType}
//                         onChange={(e) => handleLlrChange('stimulusType', e.target.value)}
//                         label="Stimulus Type"
//                         displayEmpty
//                       >
//                         <MenuItem value=""><em>Select Stimulus Type</em></MenuItem>
//                         <MenuItem value="Click">Click</MenuItem>
//                         <MenuItem value="TB500">TB500</MenuItem>
//                         <MenuItem value="TB1000">TB1000</MenuItem>
//                         <MenuItem value="TB2000">TB2000</MenuItem>
//                         <MenuItem value="TB4000">TB4000</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <FormControl fullWidth>
//                       <InputLabel shrink={true}>Ear</InputLabel>
//                       <Select
//                         value={llr.ear}
//                         onChange={(e) => handleLlrChange('ear', e.target.value)}
//                         label="Ear"
//                         displayEmpty
//                       >
//                         <MenuItem value=""><em>Select Ear</em></MenuItem>
//                         <MenuItem value="Right">Right</MenuItem>
//                         <MenuItem value="Left">Left</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <FormControl fullWidth>
//                       <InputLabel shrink={true}>Response</InputLabel>
//                       <Select
//                         value={abr.response}
//                         onChange={(e) => handleAbrChange('response', e.target.value)}
//                         label="Response"
//                         displayEmpty
//                       >
//                         <MenuItem value=""><em>Select Response</em></MenuItem>
//                         <MenuItem value="Latency">Latency</MenuItem>
//                         <MenuItem value="Amplitude">Amplitude</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>

//                 <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//                   Results
//                 </Typography>
//                 <TableContainer component={Paper} sx={{ mb: 3 }}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight: 600 }}>Intensity (dB)</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>P1</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>N1</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>P2</TableCell>
//                         <TableCell align="center" sx={{ fontWeight: 600 }}>P2/N1</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {[90, 80, 70, 60, 50, 40, 30, 20].map((intensity, rowIndex) => (
//                         <TableRow key={intensity}>
//                           <TableCell sx={{ fontWeight: 500 }}>{intensity}</TableCell>
//                           {[0, 1, 2, 3].map((colIndex) => (
//                             <TableCell key={colIndex} align="center">
//                               <TextField
//                                 size="small"
//                                 fullWidth
//                                 value={llr.results[rowIndex][colIndex]}
//                                 onChange={(e) => handleLlrResultChange(rowIndex, colIndex, e.target.value)}
//                               />
//                             </TableCell>
//                           ))}
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>

//                 <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//                   <Button
//                     variant="contained"
//                     startIcon={<SaveIcon />}
//                     onClick={saveLlr}
//                     sx={{ textTransform: 'none' }}
//                   >
//                     Save LLR
//                   </Button>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Box>

//           <Divider sx={{ my: 4 }} />

//           {/* Provisional Diagnosis Section */}
//           <Box sx={{ mb: 5 }}>
//             <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
//               11. Provisional Diagnosis
//             </Typography>
            
//             <Card variant="outlined">
//               <CardContent>
//                 <Grid container spacing={3}>
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Right Ear"
//                       value={otoscopy.rightEar}
//                       onChange={(e) => setOtoscopy(prev => ({ ...prev, rightEar: e.target.value }))}
//                       variant="outlined"
//                     />
//                   </Grid>
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Left Ear"
//                       value={otoscopy.leftEar}
//                       onChange={(e) => setOtoscopy(prev => ({ ...prev, leftEar: e.target.value }))}
//                       variant="outlined"
//                     />
//                   </Grid>
//                 </Grid>

//                 <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
//                   <Button
//                     variant="contained"
//                     startIcon={<SaveIcon />}
//                     onClick={saveOtoscopy}
//                     sx={{ textTransform: 'none' }}
//                   >
//                     Save Provisional Diagnosis
//                   </Button>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Box>

//           {/* Final Submit Button */}
//           <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
//             <Button
//               variant="contained"
//               color="primary"
//               size="large"
//               onClick={handleSubmit}
//               sx={{ 
//                 px: 6,
//                 py: 1.5,
//                 fontSize: '1.1rem',
//                 textTransform: 'none'
//               }}
//             >
//               Submit Evaluation
//             </Button>
//           </Box>
//         </Paper>
//       </Box>

//       {/* Download Modal */}
//       <Dialog 
//         open={openPasswordModal} 
//         onClose={handlePasswordModalClose}
//         maxWidth="xs"
//         fullWidth
//       >
//         <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           <Typography variant="h6">Download Data</Typography>
//           <IconButton
//             aria-label="close"
//             onClick={handlePasswordModalClose}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           <Box sx={{ mt: 2, mb: 2 }}>
//             <TextField
//               fullWidth
//               label="Enter Security Key"
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               variant="outlined"
//               sx={{ mb: 3 }}
//               helperText="Enter the security key to download data"
//             />
//             <FormControl fullWidth>
//               <InputLabel>Download Format</InputLabel>
//               <Select
//                 value={downloadFormat}
//                 onChange={(e) => setDownloadFormat(e.target.value)}
//                 label="Download Format"
//               >
//                 <MenuItem value="excel">Excel (.xlsx)</MenuItem>
//                 <MenuItem value="pdf">PDF (.pdf)</MenuItem>
//               </Select>
//             </FormControl>
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handlePasswordModalClose} color="inherit">
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleDownloadConfirm} 
//             variant="contained" 
//             color="primary"
//             disabled={!password}
//           >
//             Download
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Container>
//   );
// };

// export default HearingEvaluationChild;



import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Card,
  CardContent,
  Divider,
  Stack,
  Container,
  CircularProgress,
  Alert,
  Snackbar
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import SearchIcon from '@mui/icons-material/Search';

// Initial states
const initialPureTone = {
  mode: '', // VRA/CPA
  equipmentUsed: '',
  results: {
    rightAC: Array(10).fill(''),
    rightBC: Array(10).fill(''),
    leftAC: Array(10).fill(''),
    leftBC: Array(10).fill('')
  },
  weber: ['', '', '', '']
};

const initialBoa = {
  stimuli: Array(7).fill(''),
  intensity: Array(7).fill(''),
  response: Array(7).fill('')
};

const initialSpeech = {
  equipmentUsed: '',
  rightEar: { srt: '', sis: '', sdt: '', ucl: '' },
  leftEar: { srt: '', sis: '', sdt: '', ucl: '' }
};

const initialOtoscopy = {
  equipmentUsed: '',
  rightEar: '',
  leftEar: ''
};

const initialTympanometry = {
  equipmentUsed: '',
  rightEar: { type: '', pp: '', sa: '', width: '', ecv: '' },
  leftEar: { type: '', pp: '', sa: '', width: '', ecv: '' },
  interpretation: ''
};

const initialReflexometry = {
  equipmentUsed: '',
  rightEar: { ipsi: ['', '', '', ''], contra: ['', '', '', ''] },
  leftEar: { ipsi: ['', '', '', ''], contra: ['', '', '', ''] },
  interpretation: ''
};

const initialReflexDecay = {
  equipmentUsed: '',
  rightEar: ['', ''],
  leftEar: ['', ''],
  interpretation: ''
};

const initialOae = {
  equipmentUsed: '',
  teoae: {
    rightEar: Array(5).fill({ freq: '', snr: '', amplitude: '' }),
    leftEar: Array(5).fill({ freq: '', snr: '', amplitude: '' })
  },
  dpoae: {
    rightEar: Array(5).fill({ freq: '', snr: '', amplitude: '' }),
    leftEar: Array(5).fill({ freq: '', snr: '', amplitude: '' }),
    parameters: { f2f1: '', l1: '', l2: '' }
  },
  interpretation: ''
};

const initialAbr = {
  equipmentUsed: '',
  transducers: '',
  stimulusRate: '',
  stimulusType: '',
  ear: '',
  response: '',
  results: Array(8).fill('').map(() => Array(9).fill(''))
};

const initialLlr = {
  equipmentUsed: '',
  transducers: '',
  stimulusRate: '',
  stimulusType: '',
  ear: '',
  response: '',
  results: Array(8).fill('').map(() => Array(4).fill(''))
};

const HearingEvaluationChild = () => {
  // Main states
  const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [saveStatus, setSaveStatus] = useState({ message: '', severity: '', open: false });
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [password, setPassword] = useState('');
  const [downloadFormat, setDownloadFormat] = useState('excel');
  
  // Patient states
  const [patientId, setPatientId] = useState('');
  const [searchIdentifier, setSearchIdentifier] = useState('');
  const [patientInfo, setPatientInfo] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  
  // Form states
  const [pureTone, setPureTone] = useState(initialPureTone);
  const [boa, setBoa] = useState(initialBoa);
  const [speech, setSpeech] = useState(initialSpeech);
  const [otoscopy, setOtoscopy] = useState(initialOtoscopy);
  const [tympanometry, setTympanometry] = useState(initialTympanometry);
  const [reflexometry, setReflexometry] = useState(initialReflexometry);
  const [reflexDecay, setReflexDecay] = useState(initialReflexDecay);
  const [oae, setOae] = useState(initialOae);
  const [abr, setAbr] = useState(initialAbr);
  const [llr, setLlr] = useState(initialLlr);

  // Frequencies for pure tone audiometry
  const frequencies = [250, 500, 750, 1000, 1500, 2000, 3000, 4000, 6000, 8000];

  // BOA frequencies
  const boaFrequencies = [250, 500, 1000, 2000, 4000, 'WBN', 'Speech'];

  // Reset form function
  const resetForm = () => {
    setDate('');
    setPatientId('');
    setPatientInfo(null);
    setSearchIdentifier('');
    setPureTone(initialPureTone);
    setBoa(initialBoa);
    setSpeech(initialSpeech);
    setOtoscopy(initialOtoscopy);
    setTympanometry(initialTympanometry);
    setReflexometry(initialReflexometry);
    setReflexDecay(initialReflexDecay);
    setOae(initialOae);
    setAbr(initialAbr);
    setLlr(initialLlr);
  };

  // Handler functions
  const handlePureToneChange = (e) => {
    const { name, value } = e.target;
    setPureTone(prev => ({ ...prev, [name]: value }));
  };

  const handlePureToneResultChange = (ear, mode, index, value) => {
    setPureTone(prev => {
      const newResults = { ...prev.results };
      newResults[`${ear}${mode}`][index] = value;
      return { ...prev, results: newResults };
    });
  };

  const handleWeberChange = (index, value) => {
    setPureTone(prev => {
      const newWeber = [...prev.weber];
      newWeber[index] = value;
      return { ...prev, weber: newWeber };
    });
  };

  // BOA handlers
  const handleBoaChange = (field, index, value) => {
    setBoa(prev => ({
      ...prev,
      [field]: prev[field].map((item, i) => i === index ? value : item)
    }));
  };

  // OAE handlers
  const handleOaeTeoaeChange = (ear, index, field, value) => {
    setOae(prev => {
      const newTeoae = { ...prev.teoae };
      const newEarData = [...newTeoae[`${ear}Ear`]];
      newEarData[index] = { ...newEarData[index], [field]: value };
      newTeoae[`${ear}Ear`] = newEarData;
      return { ...prev, teoae: newTeoae };
    });
  };

  const handleOaeDpoaeChange = (ear, index, field, value) => {
    setOae(prev => {
      const newDpoae = { ...prev.dpoae };
      const newEarData = [...newDpoae[`${ear}Ear`]];
      newEarData[index] = { ...newEarData[index], [field]: value };
      newDpoae[`${ear}Ear`] = newEarData;
      return { ...prev, dpoae: newDpoae };
    });
  };

  const handleOaeParamChange = (field, value) => {
    setOae(prev => ({
      ...prev,
      dpoae: {
        ...prev.dpoae,
        parameters: {
          ...prev.dpoae.parameters,
          [field]: value
        }
      }
    }));
  };

  // ABR handlers
  const handleAbrChange = (field, value) => {
    setAbr(prev => ({ ...prev, [field]: value }));
  };

  const handleAbrResultChange = (rowIndex, colIndex, value) => {
    setAbr(prev => {
      const newResults = prev.results.map((row, rIndex) => {
        if (rIndex === rowIndex) {
          return row.map((cell, cIndex) => (cIndex === colIndex ? value : cell));
        }
        return row;
      });
      return { ...prev, results: newResults };
    });
  };

  // LLR handlers
  const handleLlrChange = (field, value) => {
    setLlr(prev => ({ ...prev, [field]: value }));
  };

  const handleLlrResultChange = (rowIndex, colIndex, value) => {
    setLlr(prev => {
      const newResults = prev.results.map((row, rIndex) => {
        if (rIndex === rowIndex) {
          return row.map((cell, cIndex) => (cIndex === colIndex ? value : cell));
        }
        return row;
      });
      return { ...prev, results: newResults };
    });
  };

  // Patient search function
  const handlePatientSearch = async () => {
    if (!searchIdentifier.trim()) {
      showAlert('Please enter IP/OP number', 'warning');
      return;
    }

    setSearchLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/hearing-evaluation/search/${searchIdentifier}`);
      
      if (!response.ok) {
        throw new Error('Patient not found');
      }

      const data = await response.json();
      setPatientInfo(data);
      setPatientId(data.id);
      
      // Auto-fill date with current date if not set
      if (!date) {
        const today = new Date().toISOString().split('T')[0];
        setDate(today);
      }
      
      showAlert('Patient found successfully!', 'success');
      
    } catch (error) {
      console.error('Error searching patient:', error);
      showAlert('Patient not found. Please check the IP/OP number.', 'error');
      setPatientInfo(null);
      setPatientId('');
    } finally {
      setSearchLoading(false);
    }
  };

  // Submit entire form
  const handleSubmit = async () => {
    try {
 

      // Prepare data object
      const allData = {
        patientId,
        date,
        pureTone,
        boa,
        speech,
        otoscopy,
        tympanometry,
        reflexometry,
        reflexDecay,
        oae,
        abr,
        llr
      };

      console.log('Submitting child hearing evaluation data:', allData);

      // Send data to backend
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/child-hearing-evaluation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(allData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      console.log('✅ Child Hearing Evaluation submitted successfully!', result);
      showAlert('✅ Child Hearing Evaluation submitted successfully!', 'success');
      
      // Reset form
      resetForm();
      
    } catch (error) {
      console.error('Error submitting child hearing evaluation:', error);
      showAlert(`❌ Error submitting form: ${error.message}`, 'error');
    } finally {
      setLoading(false);
    }
  };

  // Save handlers for each section (optional - for partial saves)
  const saveSection = async (sectionName, sectionData) => {
    try {
      if (!patientId || !date) {
        showAlert('Please select patient and date first', 'warning');
        return;
      }

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/child-hearing-evaluation/save-section`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          patientId,
          date,
          section: sectionName,
          data: sectionData
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to save ${sectionName} data`);
      }

      showAlert(`${sectionName} data saved successfully!`, 'success');
    } catch (error) {
      console.error(`Error saving ${sectionName}:`, error);
      showAlert(`Error saving ${sectionName}: ${error.message}`, 'error');
    }
  };

  const savePureTone = () => saveSection('Pure Tone', pureTone);
  const saveBoa = () => saveSection('BOA', boa);
  const saveSpeech = () => saveSection('Speech', speech);
  const saveOtoscopy = () => saveSection('Otoscopy', otoscopy);
  const saveTympanometry = () => saveSection('Tympanometry', tympanometry);
  const saveReflexometry = () => saveSection('Reflexometry', reflexometry);
  const saveReflexDecay = () => saveSection('Reflex Decay', reflexDecay);
  const saveOae = () => saveSection('OAE', oae);
  const saveAbr = () => saveSection('ABR', abr);
  const saveLlr = () => saveSection('LLR', llr);

  // Download functions
  const handleDownloadClick = () => {
    setOpenPasswordModal(true);
  };

  const handleDownloadConfirm = async () => {
    const correctKey = "Varun@6361";

    if (password !== correctKey) {
      showAlert("Incorrect key! Download canceled.", "error");
      setPassword('');
      setOpenPasswordModal(false);
      return;
    }

    setOpenPasswordModal(false);
    setLoading(true);
    showAlert(`Requesting Child Hearing Evaluation Data ${downloadFormat}...`, "info");

    try {
      const resp = await fetch(
        `${process.env.REACT_APP_API_URL}/api/reports/download-form`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            table: "child_hearing_evaluation_data",
            formName: "Child_Hearing_Evaluation_Data",
            format: downloadFormat,
            key: password
          }),
        }
      );

      if (!resp.ok) {
        const body = await resp.json().catch(() => ({}));
        showAlert(`Failed: ${body.message || resp.statusText}`, "error");
        return;
      }

      const blob = await resp.blob();
      const disposition = resp.headers.get("content-disposition") || "";

      let filename = `Child_Hearing_Evaluation_Data_${Date.now()}.${
        downloadFormat === "excel" ? "xlsx" : "pdf"
      }`;

      const match = /filename="?([^"]+)"?/.exec(disposition);
      if (match && match[1]) filename = match[1];

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      showAlert(`Download started: ${filename}`, "success");

    } catch (err) {
      console.error("Download error:", err);
      showAlert(`Error downloading file: ${err.message}`, "error");
    } finally {
      setLoading(false);
      setPassword('');
    }
  };

  const handlePasswordModalClose = () => {
    setOpenPasswordModal(false);
    setPassword('');
  };

  // Alert function
  const showAlert = (message, severity) => {
    setSaveStatus({ message, severity, open: true });
  };

  const handleCloseAlert = () => {
    setSaveStatus(prev => ({ ...prev, open: false }));
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        {/* Header Section */}
        <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0' }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
            <Stack direction="row" alignItems="center" spacing={2}>
              <NoteAddIcon sx={{ fontSize: 40, color: 'primary.main' }} />
              <Box>
                <Typography variant="h4" fontWeight={600} color="text.primary">
                  Child Hearing Evaluation
                </Typography>
           
              </Box>
            </Stack>
            
            <Button
              variant="outlined"
              color="primary"
              startIcon={<DownloadIcon />}
              onClick={handleDownloadClick}
              disabled={loading}
              sx={{ 
                borderRadius: 2,
                px: 3,
                textTransform: 'none'
              }}
            >
              Download Data
            </Button>
          </Stack>

  

          {/* Date of Assessment */}
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" fontWeight={600} gutterBottom>
                Assessment Details
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Date of Assessment"
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Paper>

        {/* Main Form */}
        <Paper elevation={0} sx={{ p: 4, border: '1px solid #e0e0e0' }}>
          {/* Pure Tone Audiometry Section */}
          <Box sx={{ mb: 5 }}>
            <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
              1. Pure Tone Audiometry
            </Typography>
            
            <Card variant="outlined">
              <CardContent>
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink={true}>Mode</InputLabel>
                      <Select
                        name="mode"
                        value={pureTone.mode}
                        onChange={handlePureToneChange}
                        label="Mode"
                        displayEmpty
                      >
                        <MenuItem value=""><em>Select Mode</em></MenuItem>
                        <MenuItem value="VRA">VRA</MenuItem>
                        <MenuItem value="CPA">CPA</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Equipment Used"
                      name="equipmentUsed"
                      value={pureTone.equipmentUsed}
                      onChange={handlePureToneChange}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>

                <TableContainer component={Paper} sx={{ mb: 3 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>Mode/Ear</TableCell>
                        {frequencies.map(freq => (
                          <TableCell key={freq} align="center" sx={{ fontWeight: 600 }}>{freq} Hz</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {[['AC', 'Right'], ['BC', 'Right'], ['AC', 'Left'], ['BC', 'Left']].map(([mode, ear]) => (
                        <TableRow key={`${mode}-${ear}`}>
                          <TableCell sx={{ fontWeight: 500 }}>{mode} - {ear}</TableCell>
                          {frequencies.map((_, index) => (
                            <TableCell key={index} align="center">
                              <TextField
                                size="small"
                                type="number"
                                value={pureTone.results[`${ear.toLowerCase()}${mode}`][index]}
                                onChange={(e) => handlePureToneResultChange(
                                  ear.toLowerCase(),
                                  mode,
                                  index,
                                  e.target.value
                                )}
                                sx={{ width: 70 }}
                              />
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Weber Test */}
                <Typography variant="subtitle1" fontWeight={600} gutterBottom sx={{ mt: 3 }}>
                  Weber Test
                </Typography>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                  {[250, 500, 1000, 2000].map((freq, index) => (
                    <Grid item xs={6} sm={3} key={freq}>
                      <FormControl fullWidth>
                        <InputLabel shrink={true}>{freq} Hz</InputLabel>
                        <Select
                          value={pureTone.weber[index]}
                          onChange={(e) => handleWeberChange(index, e.target.value)}
                          label={`${freq} Hz`}
                          displayEmpty
                        >
                          <MenuItem value=""><em>Select Weber</em></MenuItem>
                          <MenuItem value="L">Left</MenuItem>
                          <MenuItem value="R">Right</MenuItem>
                          <MenuItem value="C">Center</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  ))}
                </Grid>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={savePureTone}
                    sx={{ textTransform: 'none' }}
                  >
                    Save Pure Tone
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>

          <Divider sx={{ my: 4 }} />

          {/* Behavioral Observation Audiometry Section */}
          <Box sx={{ mb: 5 }}>
            <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
              2. Behavioral Observation Audiometry
            </Typography>
            
            <Card variant="outlined">
              <CardContent>
                <TableContainer component={Paper} sx={{ mb: 3 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}></TableCell>
                        {boaFrequencies.map(freq => (
                          <TableCell key={freq} align="center" sx={{ fontWeight: 600 }}>{freq}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>Intensity</TableCell>
                        {boaFrequencies.map((_, index) => (
                          <TableCell key={`intensity-${index}`} align="center">
                            <TextField
                              size="small"
                              type="number"
                              value={boa.intensity[index]}
                              onChange={(e) => handleBoaChange('intensity', index, e.target.value)}
                              sx={{ width: 80 }}
                            />
                          </TableCell>
                        ))}
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>Response</TableCell>
                        {boaFrequencies.map((_, index) => (
                          <TableCell key={`response-${index}`} align="center">
                            <TextField
                              size="small"
                              value={boa.response[index]}
                              onChange={(e) => handleBoaChange('response', index, e.target.value)}
                              sx={{ width: 80 }}
                            />
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={saveBoa}
                    sx={{ textTransform: 'none' }}
                  >
                    Save BOA
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>

          <Divider sx={{ my: 4 }} />

          {/* Speech Audiometry Section */}
          <Box sx={{ mb: 5 }}>
            <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
              3. Speech Audiometry
            </Typography>
            
            <Card variant="outlined">
              <CardContent>
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Equipment Used"
                      name="equipmentUsed"
                      value={speech.equipmentUsed}
                      onChange={(e) => setSpeech(prev => ({ ...prev, equipmentUsed: e.target.value }))}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>

                <TableContainer component={Paper} sx={{ mb: 3 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>Ear</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>SRT (dB HL)</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>SIS (%)</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>SDT (dB HL)</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>UCL (dB HL)</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>Right</TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            fullWidth
                            value={speech.rightEar.srt}
                            onChange={(e) => setSpeech(prev => ({
                              ...prev,
                              rightEar: { ...prev.rightEar, srt: e.target.value }
                            }))}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            fullWidth
                            value={speech.rightEar.sis}
                            onChange={(e) => setSpeech(prev => ({
                              ...prev,
                              rightEar: { ...prev.rightEar, sis: e.target.value }
                            }))}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            fullWidth
                            value={speech.rightEar.sdt}
                            onChange={(e) => setSpeech(prev => ({
                              ...prev,
                              rightEar: { ...prev.rightEar, sdt: e.target.value }
                            }))}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            fullWidth
                            value={speech.rightEar.ucl}
                            onChange={(e) => setSpeech(prev => ({
                              ...prev,
                              rightEar: { ...prev.rightEar, ucl: e.target.value }
                            }))}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>Left</TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            fullWidth
                            value={speech.leftEar.srt}
                            onChange={(e) => setSpeech(prev => ({
                              ...prev,
                              leftEar: { ...prev.leftEar, srt: e.target.value }
                            }))}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            fullWidth
                            value={speech.leftEar.sis}
                            onChange={(e) => setSpeech(prev => ({
                              ...prev,
                              leftEar: { ...prev.leftEar, sis: e.target.value }
                            }))}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            fullWidth
                            value={speech.leftEar.sdt}
                            onChange={(e) => setSpeech(prev => ({
                              ...prev,
                              leftEar: { ...prev.leftEar, sdt: e.target.value }
                            }))}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            fullWidth
                            value={speech.leftEar.ucl}
                            onChange={(e) => setSpeech(prev => ({
                              ...prev,
                              leftEar: { ...prev.leftEar, ucl: e.target.value }
                            }))}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={saveSpeech}
                    sx={{ textTransform: 'none' }}
                  >
                    Save Speech
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>

          <Divider sx={{ my: 4 }} />

          {/* Otoscopy Section */}
          <Box sx={{ mb: 5 }}>
            <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
              4. Otoscopy
            </Typography>
            
            <Card variant="outlined">
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Equipment Used"
                      value={otoscopy.equipmentUsed}
                      onChange={(e) => setOtoscopy(prev => ({ ...prev, equipmentUsed: e.target.value }))}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Right Ear Findings"
                      value={otoscopy.rightEar}
                      onChange={(e) => setOtoscopy(prev => ({ ...prev, rightEar: e.target.value }))}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Left Ear Findings"
                      value={otoscopy.leftEar}
                      onChange={(e) => setOtoscopy(prev => ({ ...prev, leftEar: e.target.value }))}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={saveOtoscopy}
                    sx={{ textTransform: 'none' }}
                  >
                    Save Otoscopy
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>

          <Divider sx={{ my: 4 }} />

          {/* Tympanometry Section */}
          <Box sx={{ mb: 5 }}>
            <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
              5. Tympanometry
            </Typography>
            
            <Card variant="outlined">
              <CardContent>
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Equipment Used"
                      value={tympanometry.equipmentUsed}
                      onChange={(e) => setTympanometry(prev => ({ ...prev, equipmentUsed: e.target.value }))}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>

                <TableContainer component={Paper} sx={{ mb: 3 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>Ear</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>Type</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>PP (daPa)</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>SA (mmho)</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>Width (daPa)</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>ECV (cc)</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>Right</TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            value={tympanometry.rightEar.type}
                            onChange={(e) => setTympanometry(prev => ({
                              ...prev,
                              rightEar: { ...prev.rightEar, type: e.target.value }
                            }))}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            value={tympanometry.rightEar.pp}
                            onChange={(e) => setTympanometry(prev => ({
                              ...prev,
                              rightEar: { ...prev.rightEar, pp: e.target.value }
                            }))}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            value={tympanometry.rightEar.sa}
                            onChange={(e) => setTympanometry(prev => ({
                              ...prev,
                              rightEar: { ...prev.rightEar, sa: e.target.value }
                            }))}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            value={tympanometry.rightEar.width}
                            onChange={(e) => setTympanometry(prev => ({
                              ...prev,
                              rightEar: { ...prev.rightEar, width: e.target.value }
                            }))}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            value={tympanometry.rightEar.ecv}
                            onChange={(e) => setTympanometry(prev => ({
                              ...prev,
                              rightEar: { ...prev.rightEar, ecv: e.target.value }
                            }))}
                            fullWidth
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>Left</TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            value={tympanometry.leftEar.type}
                            onChange={(e) => setTympanometry(prev => ({
                              ...prev,
                              leftEar: { ...prev.leftEar, type: e.target.value }
                            }))}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            value={tympanometry.leftEar.pp}
                            onChange={(e) => setTympanometry(prev => ({
                              ...prev,
                              leftEar: { ...prev.leftEar, pp: e.target.value }
                            }))}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            value={tympanometry.leftEar.sa}
                            onChange={(e) => setTympanometry(prev => ({
                              ...prev,
                              leftEar: { ...prev.leftEar, sa: e.target.value }
                            }))}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            value={tympanometry.leftEar.width}
                            onChange={(e) => setTympanometry(prev => ({
                              ...prev,
                              leftEar: { ...prev.leftEar, width: e.target.value }
                            }))}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            value={tympanometry.leftEar.ecv}
                            onChange={(e) => setTympanometry(prev => ({
                              ...prev,
                              leftEar: { ...prev.leftEar, ecv: e.target.value }
                            }))}
                            fullWidth
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  label="Interpretation"
                  value={tympanometry.interpretation}
                  onChange={(e) => setTympanometry(prev => ({ ...prev, interpretation: e.target.value }))}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={saveTympanometry}
                    sx={{ textTransform: 'none' }}
                  >
                    Save Tympanometry
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>

          <Divider sx={{ my: 4 }} />

          {/* Reflexometry Section */}
          <Box sx={{ mb: 5 }}>
            <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
              6. Reflexometry
            </Typography>
            
            <Card variant="outlined">
              <CardContent>
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Equipment Used"
                      value={reflexometry.equipmentUsed}
                      onChange={(e) => setReflexometry(prev => ({ ...prev, equipmentUsed: e.target.value }))}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>

                <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                  Right Ear
                </Typography>
                <TableContainer component={Paper} sx={{ mb: 3 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>Type</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>500 Hz</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>1000 Hz</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>2000 Hz</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>4000 Hz</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>IPSI</TableCell>
                        {[0, 1, 2, 3].map((index) => (
                          <TableCell key={`right-ipsi-${index}`} align="center">
                            <TextField
                              size="small"
                              type="number"
                              fullWidth
                              value={reflexometry.rightEar.ipsi[index]}
                              onChange={(e) => {
                                const newIpsi = [...reflexometry.rightEar.ipsi];
                                newIpsi[index] = e.target.value;
                                setReflexometry(prev => ({
                                  ...prev,
                                  rightEar: { ...prev.rightEar, ipsi: newIpsi }
                                }));
                              }}
                            />
                          </TableCell>
                        ))}
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>CONTRA</TableCell>
                        {[0, 1, 2, 3].map((index) => (
                          <TableCell key={`right-contra-${index}`} align="center">
                            <TextField
                              size="small"
                              type="number"
                              fullWidth
                              value={reflexometry.rightEar.contra[index]}
                              onChange={(e) => {
                                const newContra = [...reflexometry.rightEar.contra];
                                newContra[index] = e.target.value;
                                setReflexometry(prev => ({
                                  ...prev,
                                  rightEar: { ...prev.rightEar, contra: newContra }
                                }));
                              }}
                            />
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                  Left Ear
                </Typography>
                <TableContainer component={Paper} sx={{ mb: 3 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>Type</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>500 Hz</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>1000 Hz</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>2000 Hz</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>4000 Hz</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>IPSI</TableCell>
                        {[0, 1, 2, 3].map((index) => (
                          <TableCell key={`left-ipsi-${index}`} align="center">
                            <TextField
                              size="small"
                              type="number"
                              fullWidth
                              value={reflexometry.leftEar.ipsi[index]}
                              onChange={(e) => {
                                const newIpsi = [...reflexometry.leftEar.ipsi];
                                newIpsi[index] = e.target.value;
                                setReflexometry(prev => ({
                                  ...prev,
                                  leftEar: { ...prev.leftEar, ipsi: newIpsi }
                                }));
                              }}
                            />
                          </TableCell>
                        ))}
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>CONTRA</TableCell>
                        {[0, 1, 2, 3].map((index) => (
                          <TableCell key={`left-contra-${index}`} align="center">
                            <TextField
                              size="small"
                              type="number"
                              fullWidth
                              value={reflexometry.leftEar.contra[index]}
                              onChange={(e) => {
                                const newContra = [...reflexometry.leftEar.contra];
                                newContra[index] = e.target.value;
                                setReflexometry(prev => ({
                                  ...prev,
                                  leftEar: { ...prev.leftEar, contra: newContra }
                                }));
                              }}
                            />
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  label="Interpretation"
                  value={reflexometry.interpretation}
                  onChange={(e) => setReflexometry(prev => ({ ...prev, interpretation: e.target.value }))}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={saveReflexometry}
                    sx={{ textTransform: 'none' }}
                  >
                    Save Reflexometry
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>

          <Divider sx={{ my: 4 }} />

          {/* Reflex Decay Section */}
          <Box sx={{ mb: 5 }}>
            <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
              7. Reflex Decay
            </Typography>
            
            <Card variant="outlined">
              <CardContent>
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Equipment Used"
                      value={reflexDecay.equipmentUsed}
                      onChange={(e) => setReflexDecay(prev => ({ ...prev, equipmentUsed: e.target.value }))}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>

                <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                  Right Ear
                </Typography>
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  <Grid item xs={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink={true}>500 Hz</InputLabel>
                      <Select
                        value={reflexDecay.rightEar[0]}
                        onChange={(e) => {
                          const newRightEar = [...reflexDecay.rightEar];
                          newRightEar[0] = e.target.value;
                          setReflexDecay(prev => ({ ...prev, rightEar: newRightEar }));
                        }}
                        label="500 Hz"
                        displayEmpty
                      >
                        <MenuItem value=""><em>Select</em></MenuItem>
                        <MenuItem value="Positive">Positive</MenuItem>
                        <MenuItem value="Negative">Negative</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink={true}>1000 Hz</InputLabel>
                      <Select
                        value={reflexDecay.rightEar[1]}
                        onChange={(e) => {
                          const newRightEar = [...reflexDecay.rightEar];
                          newRightEar[1] = e.target.value;
                          setReflexDecay(prev => ({ ...prev, rightEar: newRightEar }));
                        }}
                        label="1000 Hz"
                        displayEmpty
                      >
                        <MenuItem value=""><em>Select</em></MenuItem>
                        <MenuItem value="Positive">Positive</MenuItem>
                        <MenuItem value="Negative">Negative</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                  Left Ear
                </Typography>
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  <Grid item xs={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink={true}>500 Hz</InputLabel>
                      <Select
                        value={reflexDecay.leftEar[0]}
                        onChange={(e) => {
                          const newLeftEar = [...reflexDecay.leftEar];
                          newLeftEar[0] = e.target.value;
                          setReflexDecay(prev => ({ ...prev, leftEar: newLeftEar }));
                        }}
                        label="500 Hz"
                        displayEmpty
                      >
                        <MenuItem value=""><em>Select</em></MenuItem>
                        <MenuItem value="Positive">Positive</MenuItem>
                        <MenuItem value="Negative">Negative</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink={true}>1000 Hz</InputLabel>
                      <Select
                        value={reflexDecay.leftEar[1]}
                        onChange={(e) => {
                          const newLeftEar = [...reflexDecay.leftEar];
                          newLeftEar[1] = e.target.value;
                          setReflexDecay(prev => ({ ...prev, leftEar: newLeftEar }));
                        }}
                        label="1000 Hz"
                        displayEmpty
                      >
                        <MenuItem value=""><em>Select</em></MenuItem>
                        <MenuItem value="Positive">Positive</MenuItem>
                        <MenuItem value="Negative">Negative</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  label="Interpretation"
                  value={reflexDecay.interpretation}
                  onChange={(e) => setReflexDecay(prev => ({ ...prev, interpretation: e.target.value }))}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={saveReflexDecay}
                    sx={{ textTransform: 'none' }}
                  >
                    Save Reflex Decay
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>

          <Divider sx={{ my: 4 }} />

          {/* OAE Section */}
          <Box sx={{ mb: 5 }}>
            <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
              8. Oto-acoustic Emissions (OAE)
            </Typography>
            
            <Card variant="outlined">
              <CardContent>
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Equipment Used"
                      value={oae.equipmentUsed}
                      onChange={(e) => setOae(prev => ({ ...prev, equipmentUsed: e.target.value }))}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>

                {/* TEOAE Section */}
                <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                  TEOAE
                </Typography>
                <Grid container spacing={3} sx={{ mb: 4 }}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" fontWeight={600} gutterBottom>Right Ear</Typography>
                    <TableContainer component={Paper} sx={{ mb: 2 }}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 600 }}>Frequency (KHz)</TableCell>
                            <TableCell align="center" sx={{ fontWeight: 600 }}>SNR (dB SPL)</TableCell>
                            <TableCell align="center" sx={{ fontWeight: 600 }}>Amplitude (dB SPL)</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {oae.teoae.rightEar.map((result, index) => (
                            <TableRow key={`teoae-right-${index}`}>
                              <TableCell>
                                <TextField
                                  size="small"
                                  value={result.freq}
                                  onChange={(e) => handleOaeTeoaeChange('right', index, 'freq', e.target.value)}
                                  fullWidth
                                />
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  size="small"
                                  type="number"
                                  value={result.snr}
                                  onChange={(e) => handleOaeTeoaeChange('right', index, 'snr', e.target.value)}
                                  fullWidth
                                />
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  size="small"
                                  type="number"
                                  value={result.amplitude}
                                  onChange={(e) => handleOaeTeoaeChange('right', index, 'amplitude', e.target.value)}
                                  fullWidth
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" fontWeight={600} gutterBottom>Left Ear</Typography>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 600 }}>Frequency (KHz)</TableCell>
                            <TableCell align="center" sx={{ fontWeight: 600 }}>SNR (dB SPL)</TableCell>
                            <TableCell align="center" sx={{ fontWeight: 600 }}>Amplitude (dB SPL)</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {oae.teoae.leftEar.map((result, index) => (
                            <TableRow key={`teoae-left-${index}`}>
                              <TableCell>
                                <TextField
                                  size="small"
                                  value={result.freq}
                                  onChange={(e) => handleOaeTeoaeChange('left', index, 'freq', e.target.value)}
                                  fullWidth
                                />
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  size="small"
                                  type="number"
                                  value={result.snr}
                                  onChange={(e) => handleOaeTeoaeChange('left', index, 'snr', e.target.value)}
                                  fullWidth
                                />
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  size="small"
                                  type="number"
                                  value={result.amplitude}
                                  onChange={(e) => handleOaeTeoaeChange('left', index, 'amplitude', e.target.value)}
                                  fullWidth
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>

                {/* DPOAE Section */}
                <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                  DPOAE
                </Typography>

                <Grid container spacing={2} sx={{ mb: 3 }}>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label="f2/f1"
                      variant="outlined"
                      value={oae.dpoae.parameters.f2f1}
                      onChange={(e) => handleOaeParamChange('f2f1', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label="L1"
                      variant="outlined"
                      value={oae.dpoae.parameters.l1}
                      onChange={(e) => handleOaeParamChange('l1', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label="L2"
                      variant="outlined"
                      value={oae.dpoae.parameters.l2}
                      onChange={(e) => handleOaeParamChange('l2', e.target.value)}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3} sx={{ mb: 4 }}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" fontWeight={600} gutterBottom>Right Ear</Typography>
                    <TableContainer component={Paper} sx={{ mb: 2 }}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 600 }}>Frequency (Hz)</TableCell>
                            <TableCell align="center" sx={{ fontWeight: 600 }}>SNR (dB SPL)</TableCell>
                            <TableCell align="center" sx={{ fontWeight: 600 }}>Amplitude (dB SPL)</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {oae.dpoae.rightEar.map((result, index) => (
                            <TableRow key={`dpoae-right-${index}`}>
                              <TableCell>
                                <TextField
                                  size="small"
                                  value={result.freq}
                                  onChange={(e) => handleOaeDpoaeChange('right', index, 'freq', e.target.value)}
                                  fullWidth
                                />
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  size="small"
                                  type="number"
                                  value={result.snr}
                                  onChange={(e) => handleOaeDpoaeChange('right', index, 'snr', e.target.value)}
                                  fullWidth
                                />
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  size="small"
                                  type="number"
                                  value={result.amplitude}
                                  onChange={(e) => handleOaeDpoaeChange('right', index, 'amplitude', e.target.value)}
                                  fullWidth
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" fontWeight={600} gutterBottom>Left Ear</Typography>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 600 }}>Frequency (Hz)</TableCell>
                            <TableCell align="center" sx={{ fontWeight: 600 }}>SNR (dB SPL)</TableCell>
                            <TableCell align="center" sx={{ fontWeight: 600 }}>Amplitude (dB SPL)</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {oae.dpoae.leftEar.map((result, index) => (
                            <TableRow key={`dpoae-left-${index}`}>
                              <TableCell>
                                <TextField
                                  size="small"
                                  value={result.freq}
                                  onChange={(e) => handleOaeDpoaeChange('left', index, 'freq', e.target.value)}
                                  fullWidth
                                />
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  size="small"
                                  type="number"
                                  value={result.snr}
                                  onChange={(e) => handleOaeDpoaeChange('left', index, 'snr', e.target.value)}
                                  fullWidth
                                />
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  size="small"
                                  type="number"
                                  value={result.amplitude}
                                  onChange={(e) => handleOaeDpoaeChange('left', index, 'amplitude', e.target.value)}
                                  fullWidth
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>

                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  label="Interpretation"
                  value={oae.interpretation}
                  onChange={(e) => setOae(prev => ({ ...prev, interpretation: e.target.value }))}
                  variant="outlined"
                  sx={{ mb: 2 }}
                />

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={saveOae}
                    sx={{ textTransform: 'none' }}
                  >
                    Save OAE
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>

          <Divider sx={{ my: 4 }} />

          {/* ABR Section */}
          <Box sx={{ mb: 5 }}>
            <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
              9. Auditory Brainstem Response (ABR)
            </Typography>
            
            <Card variant="outlined">
              <CardContent>
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Equipment Used"
                      value={abr.equipmentUsed}
                      onChange={(e) => handleAbrChange('equipmentUsed', e.target.value)}
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink={true}>Transducers</InputLabel>
                      <Select
                        value={abr.transducers}
                        onChange={(e) => handleAbrChange('transducers', e.target.value)}
                        label="Transducers"
                        displayEmpty
                      >
                        <MenuItem value=""><em>Select Transducer</em></MenuItem>
                        <MenuItem value="Insert receiver">Insert receiver</MenuItem>
                        <MenuItem value="BC">BC</MenuItem>
                        <MenuItem value="Headphones">Headphones</MenuItem>
                        <MenuItem value="Loudspeaker">Loudspeaker</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink={true}>Stimulus Rate</InputLabel>
                      <Select
                        value={abr.stimulusRate}
                        onChange={(e) => handleAbrChange('stimulusRate', e.target.value)}
                        label="Stimulus Rate"
                        displayEmpty
                      >
                        <MenuItem value=""><em>Select Stimulus Rate</em></MenuItem>
                        <MenuItem value="11.1">11.1</MenuItem>
                        <MenuItem value="30.1">30.1</MenuItem>
                        <MenuItem value="90.1">90.1</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink={true}>Stimulus Type</InputLabel>
                      <Select
                        value={abr.stimulusType}
                        onChange={(e) => handleAbrChange('stimulusType', e.target.value)}
                        label="Stimulus Type"
                        displayEmpty
                      >
                        <MenuItem value=""><em>Select Stimulus Type</em></MenuItem>
                        <MenuItem value="Click">Click</MenuItem>
                        <MenuItem value="TB500">TB500</MenuItem>
                        <MenuItem value="TB1000">TB1000</MenuItem>
                        <MenuItem value="TB2000">TB2000</MenuItem>
                        <MenuItem value="TB4000">TB4000</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink={true}>Ear</InputLabel>
                      <Select
                        value={abr.ear}
                        onChange={(e) => handleAbrChange('ear', e.target.value)}
                        label="Ear"
                        displayEmpty
                      >
                        <MenuItem value=""><em>Select Ear</em></MenuItem>
                        <MenuItem value="Right">Right</MenuItem>
                        <MenuItem value="Left">Left</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink={true}>Response</InputLabel>
                      <Select
                        value={abr.response}
                        onChange={(e) => handleAbrChange('response', e.target.value)}
                        label="Response"
                        displayEmpty
                      >
                        <MenuItem value=""><em>Select Response</em></MenuItem>
                        <MenuItem value="Latency">Latency</MenuItem>
                        <MenuItem value="Amplitude">Amplitude</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                  Results
                </Typography>
                <TableContainer component={Paper} sx={{ mb: 3 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>Intensity (dB)</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>I</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>II</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>III</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>IV</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>V</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>I-III</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>III-V</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>V/I</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>Interaural V</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {[90, 80, 70, 60, 50, 40, 30, 20].map((intensity, rowIndex) => (
                        <TableRow key={intensity}>
                          <TableCell sx={{ fontWeight: 500 }}>{intensity}</TableCell>
                          {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((colIndex) => (
                            <TableCell key={colIndex} align="center">
                              <TextField
                                size="small"
                                fullWidth
                                value={abr.results[rowIndex][colIndex]}
                                onChange={(e) => handleAbrResultChange(rowIndex, colIndex, e.target.value)}
                              />
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={saveAbr}
                    sx={{ textTransform: 'none' }}
                  >
                    Save ABR
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>

          <Divider sx={{ my: 4 }} />

          {/* LLR Section */}
          <Box sx={{ mb: 5 }}>
            <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
              10. Late Latency Response (LLR)
            </Typography>
            
            <Card variant="outlined">
              <CardContent>
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Equipment Used"
                      value={llr.equipmentUsed}
                      onChange={(e) => handleLlrChange('equipmentUsed', e.target.value)}
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink={true}>Transducers</InputLabel>
                      <Select
                        value={llr.transducers}
                        onChange={(e) => handleLlrChange('transducers', e.target.value)}
                        label="Transducers"
                        displayEmpty
                      >
                        <MenuItem value=""><em>Select Transducer</em></MenuItem>
                        <MenuItem value="Insert receiver">Insert receiver</MenuItem>
                        <MenuItem value="BC">BC</MenuItem>
                        <MenuItem value="Headphones">Headphones</MenuItem>
                        <MenuItem value="Loudspeaker">Loudspeaker</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink={true}>Stimulus Rate</InputLabel>
                      <Select
                        value={llr.stimulusRate}
                        onChange={(e) => handleLlrChange('stimulusRate', e.target.value)}
                        label="Stimulus Rate"
                        displayEmpty
                      >
                        <MenuItem value=""><em>Select Stimulus Rate</em></MenuItem>
                        <MenuItem value="11.1">11.1</MenuItem>
                        <MenuItem value="30.1">30.1</MenuItem>
                        <MenuItem value="90.1">90.1</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink={true}>Stimulus Type</InputLabel>
                      <Select
                        value={llr.stimulusType}
                        onChange={(e) => handleLlrChange('stimulusType', e.target.value)}
                        label="Stimulus Type"
                        displayEmpty
                      >
                        <MenuItem value=""><em>Select Stimulus Type</em></MenuItem>
                        <MenuItem value="Click">Click</MenuItem>
                        <MenuItem value="TB500">TB500</MenuItem>
                        <MenuItem value="TB1000">TB1000</MenuItem>
                        <MenuItem value="TB2000">TB2000</MenuItem>
                        <MenuItem value="TB4000">TB4000</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink={true}>Ear</InputLabel>
                      <Select
                        value={llr.ear}
                        onChange={(e) => handleLlrChange('ear', e.target.value)}
                        label="Ear"
                        displayEmpty
                      >
                        <MenuItem value=""><em>Select Ear</em></MenuItem>
                        <MenuItem value="Right">Right</MenuItem>
                        <MenuItem value="Left">Left</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink={true}>Response</InputLabel>
                      <Select
                        value={llr.response}
                        onChange={(e) => handleLlrChange('response', e.target.value)}
                        label="Response"
                        displayEmpty
                      >
                        <MenuItem value=""><em>Select Response</em></MenuItem>
                        <MenuItem value="Latency">Latency</MenuItem>
                        <MenuItem value="Amplitude">Amplitude</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                  Results
                </Typography>
                <TableContainer component={Paper} sx={{ mb: 3 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>Intensity (dB)</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>P1</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>N1</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>P2</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 600 }}>P2/N1</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {[90, 80, 70, 60, 50, 40, 30, 20].map((intensity, rowIndex) => (
                        <TableRow key={intensity}>
                          <TableCell sx={{ fontWeight: 500 }}>{intensity}</TableCell>
                          {[0, 1, 2, 3].map((colIndex) => (
                            <TableCell key={colIndex} align="center">
                              <TextField
                                size="small"
                                fullWidth
                                value={llr.results[rowIndex][colIndex]}
                                onChange={(e) => handleLlrResultChange(rowIndex, colIndex, e.target.value)}
                              />
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={saveLlr}
                    sx={{ textTransform: 'none' }}
                  >
                    Save LLR
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>

          <Divider sx={{ my: 4 }} />

          {/* Provisional Diagnosis Section */}
          <Box sx={{ mb: 5 }}>
            <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
              11. Provisional Diagnosis
            </Typography>
            
            <Card variant="outlined">
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Right Ear"
                      multiline
                      rows={3}
                      value={otoscopy.rightEar}
                      onChange={(e) => setOtoscopy(prev => ({ ...prev, rightEar: e.target.value }))}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Left Ear"
                      multiline
                      rows={3}
                      value={otoscopy.leftEar}
                      onChange={(e) => setOtoscopy(prev => ({ ...prev, leftEar: e.target.value }))}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={saveOtoscopy}
                    sx={{ textTransform: 'none' }}
                  >
                    Save Provisional Diagnosis
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>

          {/* Final Submit Button */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleSubmit}
           
              sx={{ 
                px: 6,
                py: 1.5,
                fontSize: '1.1rem',
                textTransform: 'none'
              }}
            >
              {loading ? <CircularProgress size={24} /> : 'Submit Evaluation'}
            </Button>
          </Box>
        </Paper>
      </Box>

      {/* Download Modal */}
      <Dialog 
        open={openPasswordModal} 
        onClose={handlePasswordModalClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Download Data</Typography>
          <IconButton
            aria-label="close"
            onClick={handlePasswordModalClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Enter Security Key"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="outlined"
              sx={{ mb: 3 }}
              helperText="Enter the security key to download data"
            />
            <FormControl fullWidth>
              <InputLabel>Download Format</InputLabel>
              <Select
                value={downloadFormat}
                onChange={(e) => setDownloadFormat(e.target.value)}
                label="Download Format"
              >
                <MenuItem value="excel">Excel (.xlsx)</MenuItem>
                <MenuItem value="pdf">PDF (.pdf)</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handlePasswordModalClose} color="inherit">
            Cancel
          </Button>
          <Button 
            onClick={handleDownloadConfirm} 
            variant="contained" 
            color="primary"
            disabled={!password}
          >
            Download
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for alerts */}
      <Snackbar
        open={saveStatus.open}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleCloseAlert} 
          severity={saveStatus.severity} 
          sx={{ width: '100%' }} 
        >
          {saveStatus.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default HearingEvaluationChild;